// extracted by mini-css-extract-plugin
export default {"title":"Support_title__+UXzD","subtitle":"Support_subtitle__ladmY","email":"Support_email__jUuxP","icon":"Support_icon__5dU9e"};